
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chiamaci",
      function () {
        return require("private-next-pages/chiamaci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chiamaci"])
      });
    }
  